import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { SpinnerType } from 'app/base/enums';
import { BaseComponent } from 'app/base/base.component';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';

import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { environment } from 'environments/environment.prod';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  form!: FormGroup;
  @ViewChild('emailInput') emailInput!: ElementRef<HTMLInputElement>;
  constructor(
    private fb: FormBuilder,
    private authService: UnifiedAuthService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private toastr: CustomToastrService,

    spinner: NgxSpinnerService
  ) {
    super(spinner);
  }
  private autofillInterval: any;
  ngOnInit() {
    this.form = this.fb.group({
      email: [''],
      password: [''],
      isAdmin: [false],
      isAkademik: [false],
      rememberMe: [false],
    });

    this.loginCheck();
    this.loadRemembered();
  }
  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    if (this.autofillInterval) {
      clearInterval(this.autofillInterval);
    }
  }


  onOkulNoChange(event: any) {

  }

  loginCheck() {
    if (this.authService.isLoggedIn$) {
      this.toastr.message('Oturumunuz Kapatıldı.', '', {
        messageType: ToastrMessageType.Info,
        position: ToastrPosition.TopFullWidth,
      });
    }
  }

  onRoleToggle(event: any) {
    if (event.checked) {
      this.form.value.isAdmin = true;
    } else {
      this.form.value.isAdmin = false;
    }
  }



  async onSubmit() {
    const input = this.emailInput.nativeElement;

    const emailValue = input.value?.trim();




    const email = this.form.value.email;
    const password = this.form.value.password;
    const isAdmin = this.form.value.isAdmin;
    const remember = this.form.value.rememberMe;

    this.spinnerShow(SpinnerType.BallAtom);

    if (isAdmin) {
      // **YÖNETİCİ GİRİŞİ**
      await this.authService.login(email, password, true).then(() => {
        this.afterLogin(remember);
      });
    } else {
      // **ÖĞRENCİ/Hoca GİRİŞİ**
      await this.authService
        .login(email, password, false)
        .then(() => {
          this.afterLogin(remember);
        });
    }
  }
afterLogin(remember: boolean) {
  if (remember) {
    localStorage.setItem('rememberEmail', this.form.value.email);
    localStorage.setItem('rememberPassword', this.form.value.password); // ✅ EKLENDİ

  } else {
    localStorage.removeItem('rememberEmail');
    localStorage.removeItem('rememberPassword'); // ✅ EKLENDİ

  }

  this.router.navigate(['welcome'], { queryParams: { version: environment.version } });
  this.spinnerHide(SpinnerType.BallAtom);
}

  loadRemembered() {
    const remEmail = localStorage.getItem('rememberEmail');
    const remPassword = localStorage.getItem('rememberPassword');

    if (remEmail) {
      this.form.controls['email'].setValue(remEmail);
    }
    if (remPassword) {
      this.form.controls['password'].setValue(remPassword);
    }
  }
}


